import { IOfferingProductSchema } from '@monetize/types/app';
import { useMemo } from 'react';
import { useFlags } from '../../../../../services/launchDarkly';

export const useDiscountDisabledProducts = (
  offeringProducts: IOfferingProductSchema[],
) => {
  const { disableDiscountLifted } = useFlags();

  const discountDisabledProductIds = useMemo(() => {
    if (
      disableDiscountLifted &&
      disableDiscountLifted?.productCustomIds?.length &&
      disableDiscountLifted?.productCustomIds?.length > 0
    ) {
      return offeringProducts
        .filter(
          (product) =>
            product.product.customId &&
            disableDiscountLifted?.productCustomIds?.includes(
              product.product.customId || '',
            ),
        )
        .map((product) => product.product.id);
    }

    return [];
  }, [offeringProducts, disableDiscountLifted]);

  return { discountDisabledProductIds };
};
